export default __webpack_public_path__ + "static/media/5.e71a4fae.svg";